import SimpleSelect from './SimpleSelect.vue';

SimpleSelect.install = (Vue) => {
  Vue.component(SimpleSelect.name, SimpleSelect);
};

export default SimpleSelect;
